module.exports = __webpack_public_path__ + "img/card-right-arrow-icon.2154802e.svg";